/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Contract_Overage_LabelInputs */



/**
* | output |
* | --- |
* | "Allow pay-per-use after the budget" |
*
* @param {Partner_Contract_Overage_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_contract_overage_label = /** @type {((inputs?: Partner_Contract_Overage_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Contract_Overage_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsbasierte Abrechnung nach dem Budget erlauben")
	return /** @type {LocalizedString} */ ("Allow pay-per-use after the budget")
});